import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { createConversation } from '../../../../api/conversations';

import Context from '../../../../utils/context';

import styles from '../../questionnaire.module.css';

const BIO_TRUNCATE_THRESHOLD = 2000;

export default function MentorCard({ mentor, callback = null, stateOnlyLocation = false }) {
  const [showBio, setShowBio] = React.useState(false);
  const bioIsLong = (mentor.bio?.length || 0) > BIO_TRUNCATE_THRESHOLD;
  const context = useContext(Context);

  let history = useHistory();

  const sendAMessage = () => {
    if (context.auth.isLoggedIn()) {
      createConversation({ patient_partner_id: mentor.id }, (conversation) => {
        if (callback) {
          callback(conversation);
        } else {
          history.push(`/member/conversations/${conversation.uuid}`);
        }
      });
    } else {
      history.push(`/member/join/support?patient_partner_id=${mentor.id}`);
    }
  };

  const imageUrl = mentor.profile?.photo || '';

  const location = stateOnlyLocation ? mentor.profile?.state : mentor.profile?.display_location;

  return (
    <div className={`content_container container`}>
      <div className='row'>
        <div className='col col-md-7' style={{ paddingRight: '0px' }}>
          <div style={{ display: 'flex' }}>
            <div className={styles.photo} style={{ backgroundImage: `url(${imageUrl})` }} alt='mentor' />
            <div style={{ marginLeft: '16px' }}>
              <p className={styles.name}>
                {mentor.name} <span className={styles.mentor_tag}>mentor</span>
              </p>
              <p className={styles.location}>{location}</p>
            </div>
          </div>
        </div>
      </div>

      <div className='row' style={{ marginTop: '10px' }}>
        <div className='col'>
          <p>
            {mentor.focus_areas.map((focusArea, i) => (
              <span key={i} className={styles.sot}>
                {i !== 0 && `, `}
                {focusArea}
              </span>
            ))}
          </p>
        </div>
      </div>

      <div className='row'>
        <div className='col'>
          <div className={`${styles.para} ${bioIsLong && !showBio ? styles.short : ''}`}>
            {(mentor.bio || '')
              .split(/\n+/)
              .map((paragraph) => paragraph.trim())
              .filter(Boolean)
              .map((paragraph, i) => (
                <div key={i} style={{ marginTop: i === 0 ? 0 : '12px' }}>
                  {paragraph}
                </div>
              ))}
          </div>
          {bioIsLong && (
            <p
              style={{ cursor: 'pointer', marginTop: '10px' }}
              onClick={() => setShowBio(!showBio)}
              className={styles.sot}
            >
              {showBio ? 'Show less' : 'Read More'}
            </p>
          )}
        </div>
      </div>

      <div className='row'>
        <div className='col'>
          <button
            id={`mentor_send_message_button-${mentor.account_slug}`}
            style={{ width: '100%', display: 'block', marginTop: '15px' }}
            data-pendo-tag='Surgeon Page - Mentor - send a message'
            onClick={() => sendAMessage()}
          >
            Send a message
          </button>
        </div>
      </div>
    </div>
  );
}
